<script setup lang="ts">
  import { inject, onMounted, provide, useTemplateRef } from 'vue'
  import { accessRolesCollectionKey } from '@gat-ship/types/injection-keys'
  import { useAccessRolesCollection } from '../../composables/useAccessRolesCollection'
  import AccessRoleModalAdd from '../modals/AccessRoleModalAdd.vue'
  import {
    provideAccessRolesCollection,
    type ShowAddAccessRoleDialogParams
  } from './access-roles-collection-context'

  const props = withDefaults(
    defineProps<{
      fetchOnMount?: boolean
    }>(),
    {
      fetchOnMount: false
    }
  )

  const dataSource =
    inject(accessRolesCollectionKey, undefined) ?? useAccessRolesCollection()
  const modalAddAccessRoleRef = useTemplateRef('modalAddAccessRoleRef')

  onMounted(() => {
    if (props.fetchOnMount) {
      dataSource.fetchAccessRoles()
    }
  })

  // Expose the collection under the cross-package key as well, so descendant
  // detail providers can resolve the SHARED instance via inject (the reka-ui
  // context below cannot cross a package boundary).
  provide(accessRolesCollectionKey, dataSource)

  provideAccessRolesCollection({
    dataSource,
    modals: {
      showAddAccessRole: (params: ShowAddAccessRoleDialogParams) => {
        modalAddAccessRoleRef.value?.showModal(params)
      }
    }
  })

  defineExpose({
    dataSource
  })
</script>

<template>
  <slot />
  <AccessRoleModalAdd ref="modalAddAccessRoleRef" />
</template>
